<div class="d-flex flex-column align-items-center my-4 overflow-hidden">
    <a *adaptIfAuthorised="ReadStrategyGoal; else notAuthorised"
       class="btn btn-primary px-4 mt-3"
       [routerLink]="route?.path"
       [queryParams]="route?.queryParams">See your strategic goals</a>
    <ng-template #notAuthorised>
        <span>This feature is enabled only for the Growth+ platform subscription.</span>
    </ng-template>
</div>
